import { MapPin, Clock, Car, Navigation } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
export default function OurCampus() {
  return <section data-section-id="151591" id="our-latrobe-office" className="relative w-full min-h-[600px] md:min-h-[700px] bg-background text-foreground overflow-hidden flex items-center">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1601078/img/carnelian_campus_map_bg.png" alt="Map of Lavers Business Consulting Latrobe office area" className="w-full h-full object-cover grayscale contrast-125 opacity-40" />
        
        {}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
          <div className="relative">
            <div className="absolute inset-0 bg-secondary/20 rounded-full animate-ping scale-150" />
            <MapPin className="relative z-10 size-12 text-secondary drop-shadow-lg" fill="currentColor" />
          </div>
          <div className="mt-3 px-4 py-1.5 bg-card/95 backdrop-blur-sm rounded-sm text-xs font-mono font-bold text-foreground shadow-sm border border-border/50 uppercase tracking-widest">
            Lavers Business Consulting
          </div>
        </div>
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 md:px-6 w-full flex justify-start">
        <Card className="w-full max-w-md shadow-md bg-card/95 backdrop-blur-md border-border/50 rounded-sm">
          <CardHeader className="pb-4">
            <CardTitle className="text-3xl font-sans font-bold tracking-tight text-primary">Our Latrobe Office</CardTitle>
            <CardDescription className="text-sm font-sans text-muted-foreground">
              Strategic consulting for business efficiency and growth.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            
            {}
            <div className="flex items-start gap-4">
              <div className="bg-secondary/10 p-2 rounded-sm shrink-0">
                <MapPin className="size-5 text-secondary" />
              </div>
              <div>
                <h4 className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mb-1">Location</h4>
                <p className="text-foreground leading-relaxed text-sm">
                  20 Spring GR<br />
                  Latrobe, TAS 7308, Australia
                </p>
              </div>
            </div>

            {}
            <div className="flex items-start gap-4">
              <div className="bg-secondary/10 p-2 rounded-sm shrink-0">
                <Clock className="size-5 text-secondary" />
              </div>
              <div>
                <h4 className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mb-1">Hours of Operation</h4>
                <p className="text-foreground leading-relaxed text-sm">
                  Monday - Friday: 8:30am - 5:30pm<br />
                  Weekend: By Appointment
                </p>
              </div>
            </div>

            {}
            <div className="flex items-start gap-4">
              <div className="bg-secondary/10 p-2 rounded-sm shrink-0">
                <Car className="size-5 text-secondary" />
              </div>
              <div>
                <h4 className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mb-1">Parking Information</h4>
                <p className="text-foreground leading-relaxed text-sm">
                  On-site client parking is available at the front of the building. Additional space is located along Spring Grove for your convenience.
                </p>
              </div>
            </div>

          </CardContent>
          <CardFooter className="pt-2">
            <Button className="w-full rounded-sm h-12 text-sm font-sans font-bold bg-secondary text-secondary-foreground hover:bg-secondary/90 shadow-sm transition-colors" asChild>
              <Link to="#">
                <Navigation className="mr-2 size-4" />
                Get Directions
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}